import { useEffect, useState } from "react";
import styled from "styled-components";

const Dropdown = ({
  questionsLength,
  question,
  pageQuestions,
  index,
  answeredQuestions,
  setAnsweredQuestions,
  setCurrentPageAnswers,
  currentPage,
  setCurrentPage,
  currentPageAnswers,
  parseDynamicQuestionText,
  showQuestion,
  errors,
  setErrors,
}) => {
  let allAnsweredQuestions = [];
  answeredQuestions.forEach((ans) => {
    if (typeof ans === "object") {
      if (ans.length === 1) {
        typeof ans[0] !== "object"
          ? allAnsweredQuestions.push(ans[0])
          : ans[0].forEach((ansNested) => allAnsweredQuestions.push(ansNested));
      } else if (ans.length > 1) {
        ans.forEach((answer) =>
          typeof answer !== "object"
            ? allAnsweredQuestions.push(answer)
            : answer.forEach((ansNested) =>
                allAnsweredQuestions.push(ansNested)
              )
        );
      }
    } else {
      allAnsweredQuestions.push(ans);
    }
  });

              

  allAnsweredQuestions = allAnsweredQuestions.filter((ans) => ans);

  const [loadQuestion, setLoadQuestion] = useState(false)
  const [displayTitle, setDisplayTitle] = useState(false)

                          

  useEffect(() => {
    let pageQuestionsCopy = pageQuestions
                      
    if (pageQuestionsCopy.some((individualQuestion) => individualQuestion.Answers.some((answer) => {
      return (answer.showIf
        ? 
        answer.showIf.replace("<>", "!==")?.replace(/</g, "")?.replace(/>/g, "").split(/\|\||&&/).map(ans => ans.replace("((","").replace("))","").replace("(","").replace(")","").replace("<","").replace(">","")).some(ans => currentPageAnswers.includes(ans))
          ||
          (answer.showIf.includes("!==")
            ? 
            !answer.showIf.replace("<>", "!==")?.replace(/</g, "")?.replace(/>/g, "").split(/\|\||&&/).map(ans => ans.replace("((","").replace("))","").replace("(","").replace(")","").replace("<","").replace(">","").replace("!=", "")).some(ans => allAnsweredQuestions.includes(ans))
            : 
            showQuestion(answer.showIf))
        : true)
    }))) {
           
      if (question.Answers.some(
        (answer) =>
          (answer.showIf
            ? 
            answer.showIf.replace("<>", "!==")?.replace(/</g, "")?.replace(/>/g, "").split(/\|\||&&/).map(ans => ans.replace("((","").replace("))","").replace("(","").replace(")","").replace("<","").replace(">","")).some(ans => currentPageAnswers.includes(ans))
              ||
              (answer.showIf.includes("!==")
                ? 
                !answer.showIf.replace("<>", "!==")?.replace(/</g, "")?.replace(/>/g, "").split(/\|\||&&/).map(ans => ans.replace("((","").replace("))","").replace("(","").replace(")","").replace("<","").replace(">","").replace("!=", "")).some(ans => allAnsweredQuestions.includes(ans))
                : 
              showQuestion(answer.showIf))
            : true))) {
              setLoadQuestion(true)
                 
              if (pageQuestionsCopy.map((individualQuestion) => individualQuestion.Answers.some((answer) => {
                return (answer.showIf
                  ? currentPageAnswers?.includes(
                      answer.showIf
                        .replace("<>", "!==")
                        .replace(/</g, "")
                        .replace(/>/g, "")
                        .replace("(", "")
                        .replace(")", "")
                        .replace(" ", "")
                    ) ||
                    (answer.showIf.includes("!==")
                      ? !allAnsweredQuestions.includes(
                          answer.showIf
                            .replace("!==", "=")
                            .replace(/</g, "")
                            .replace(/>/g, "")
                            .replace("(", "")
                            .replace(")", "")
                            .replace(" ", "")
                        )
                      : allAnsweredQuestions.includes(
                          answer.showIf
                            .replace("<>", "!==")
                            .replace(/</g, "")
                            .replace(/>/g, "")
                            .replace("(", "")
                            .replace(")", "")
                            .replace(" ", "")
                        )
                    )
                  : true)})).filter(ans => ans).length === 1 && pageQuestionsCopy.findIndex((individualQuestion) => individualQuestion.Answers.some((answer) => {
                      return (answer.showIf
                        ? 
                          answer.showIf.replace("<>", "!==")?.replace(/</g, "")?.replace(/>/g, "").split(/\|\||&&/).map(ans => ans.replace("((","").replace("))","").replace("(","").replace(")","").replace("<","").replace(">","")).some(ans => currentPageAnswers.includes(ans))
                          ||
                          (answer.showIf.includes("!==")
                            ? 
                            !answer.showIf.replace("<>", "!==")?.replace(/</g, "")?.replace(/>/g, "").split(/\|\||&&/).map(ans => ans.replace("((","").replace("))","").replace("(","").replace(")","").replace("<","").replace(">","").replace("!=", "")).some(ans => allAnsweredQuestions.includes(ans))
                            : 
                          showQuestion(answer.showIf))
                        : true)})) === index) {
                             
                setDisplayTitle(true)
              }
            }
    } else {
       
      if (window.direction === "next") {
                       
        setCurrentPage(currentPage + 1)
      } else if (window.direction === "back") {
                       
        setCurrentPage(currentPage - 1)
      }
    }

                    

    if (!answeredQuestions[currentPage - 1] || !answeredQuestions[currentPage - 1]?.length || (answeredQuestions[currentPage - 1].every(answer => answer.includes('=null')) || answeredQuestions[currentPage - 1].every(answer => answer.includes('=-998')))) {
      let answeredQuestionsCopy = [...answeredQuestions]

      if (!answeredQuestionsCopy[currentPage - 1]) {
        answeredQuestionsCopy[currentPage - 1] = []
      }
      answeredQuestionsCopy[currentPage - 1] = pageQuestions.map(questionObj => `${questionObj.Answers[0].Expression.split('=')[0]}=-998`)

      setAnsweredQuestions(answeredQuestionsCopy)
      setCurrentPageAnswers(answeredQuestionsCopy[currentPage - 1])
    }


  }, [currentPage])

  useEffect(() => {
    let pageQuestionsCopy = pageQuestions
                      
    if (question.Answers.some(
      (answer) =>
        (answer.showIf ?
        answer.showIf.replace("<>", "!==")?.replace(/</g, "")?.replace(/>/g, "").split(/\|\||&&/).map(ans => ans.replace("((","").replace("))","").replace("(","").replace(")","").replace("<","").replace(">","")).some(ans => currentPageAnswers.includes(ans))
        ||
        (answer.showIf.includes("!==") ?
        !answer.showIf.replace("<>", "!==")?.replace(/</g, "")?.replace(/>/g, "").split(/\|\||&&/).map(ans => ans.replace("((","").replace("))","").replace("(","").replace(")","").replace("<","").replace(">","").replace("!=", "")).some(ans => allAnsweredQuestions.includes(ans))
        :
        showQuestion(answer.showIf))
        : true ))) {
            setLoadQuestion(true)  
               
            if (pageQuestionsCopy.map((individualQuestion) => individualQuestion.Answers.some((answer) => {
              return (answer.showIf
                ? 
                  answer.showIf.replace("<>", "!==")?.replace(/</g, "")?.replace(/>/g, "").split(/\|\||&&/).map(ans => ans.replace("((","").replace("))","").replace("(","").replace(")","").replace("<","").replace(">","")).some(ans => currentPageAnswers.includes(ans))
                  ||
                  (answer.showIf.includes("!==")
                    ? 
                    !answer.showIf.replace("<>", "!==")?.replace(/</g, "")?.replace(/>/g, "").split(/\|\||&&/).map(ans => ans.replace("((","").replace("))","").replace("(","").replace(")","").replace("<","").replace(">","").replace("!=", "")).some(ans => allAnsweredQuestions.includes(ans))
                    : 
                    showQuestion(answer.showIf)
                  )
                : true)})).filter(ans => ans).length === 1 && pageQuestionsCopy.findIndex((individualQuestion) => individualQuestion.Answers.some((answer) => {
                    return (answer.showIf
                      ? 
                        answer.showIf.replace("<>", "!==")?.replace(/</g, "")?.replace(/>/g, "").split(/\|\||&&/).map(ans => ans.replace("((","").replace("))","").replace("(","").replace(")","").replace("<","").replace(">","")).some(ans => currentPageAnswers.includes(ans))
                        ||
                        (answer.showIf.includes("!==")
                          ? 
                            !answer.showIf.replace("<>", "!==")?.replace(/</g, "")?.replace(/>/g, "").split(/\|\||&&/).map(ans => ans.replace("((","").replace("))","").replace("(","").replace(")","").replace("<","").replace(">","").replace("!=", "")).some(ans => allAnsweredQuestions.includes(ans))
                          : 
                          showQuestion(answer.showIf)
                        )
                      : true)})) === index) {
                           
              setDisplayTitle(true)
            }
          }

  }, [currentPageAnswers])

  const handleChange = (event, index) => {
    //check to see if previous answered questions are still relevant
    let relevantQuestionCodeArray = pageQuestions.map((individualQuestion) => { 
      return (individualQuestion.Answers.some((answer) => {
                  return (answer.showIf
                    ? (currentPageAnswers?.includes(
                        answer.showIf
                          .replace("<>", "!==")
                          .replace(/</g, "")
                          .replace(/>/g, "")
                          .replace("(", "")
                          .replace(")", "")
                          .replace(" ", "")
                      ) ||
                      (answer.showIf.includes("!==")
                        ? !allAnsweredQuestions.includes(
                            answer.showIf
                              .replace("!==", "=")
                              .replace(/</g, "")
                              .replace(/>/g, "")
                              .replace("(", "")
                              .replace(")", "")
                              .replace(" ", "")
                          )  
                        : allAnsweredQuestions.includes(
                            answer.showIf
                              .replace("<>", "!==")
                              .replace(/</g, "")
                              .replace(/>/g, "")
                              .replace("(", "")
                              .replace(")", "")
                              .replace(" ", "")
                          )
                      ))
    : true )}) ? individualQuestion.Answers[0].Expression.split('=')[0] : false)}).filter(ans => ans) 
    let newAnswerArray = currentPageAnswers.filter(ans => relevantQuestionCodeArray.includes(ans.split('=')[0]))

    let answeredQuestionsCopy = [...answeredQuestions];
               
    answeredQuestionsCopy[currentPage - 1] = newAnswerArray.filter(ans => (typeof ans === "string" && !ans?.includes('=-998') && !ans?.includes('=null'))).map((string) => string.split("=")[0])
    ?.includes(event.target.value.split("=")[0])
    ? [
        ...newAnswerArray?.filter(
          (val) =>
            (!val?.split("=")[0]?.includes(event.target.value.split("=")[0]) && !val?.includes('=null') && !val?.includes('=-998'))
        ),
        event.target.value,
      ]
    : [...newAnswerArray?.filter(val => !val?.includes('=null')).filter(val => val.split('=')[0] !== event.target.value.split('=')[0]), event.target.value];   

                
    setAnsweredQuestions(answeredQuestionsCopy);
    setCurrentPageAnswers(answeredQuestionsCopy[currentPage - 1]);
  };

  if (loadQuestion) { 
    return (
      <>
        {index === 0 ? (
          <>
          {question.QuestionHead ? <h2 dangerouslySetInnerHTML={{ __html: parseDynamicQuestionText(question.QuestionHead, true)}} ></h2> : <></>}
          {question.QuestionName ? <h3 dangerouslySetInnerHTML={{ __html: parseDynamicQuestionText(question.QuestionName, true)}} ></h3> : <></>}
          </>
        ) : displayTitle ? 
        <>
          {question.QuestionHead ? <h2 dangerouslySetInnerHTML={{ __html: parseDynamicQuestionText(question.QuestionHead, true)}} ></h2> : <></>}
          {question.QuestionName ? <h3 dangerouslySetInnerHTML={{ __html: parseDynamicQuestionText(question.QuestionName, true)}} ></h3> : <></>}
        </>
        : null}
        <StyledDropdown>
          <StyledSelect onChange={(e) => handleChange(e, index)}>
            <StyledOption
              value=""
              disabled
              selected={
                !answeredQuestions[currentPage - 1]?.find((answer) =>
                  answer.includes(question.Answers[0].Expression.split("=")[0])
                ) || answeredQuestions[currentPage - 1]?.find((answer) =>
                  answer.includes(question.Answers[0].Expression.split("=")[0])
                )?.includes('=-998')
              }
            >
              {question?.DropDownPleaseSelect
                ? question?.DropDownPleaseSelect
                : "Please Select"}
            </StyledOption>
            {question.Answers.map(
              (answer, index) => {
                                  
                return (answer.showIf
                  ? 
                  answer.showIf.replace("<>", "!==")?.replace(/</g, "")?.replace(/>/g, "").split(/\|\||&&/).map(ans => ans.replace("((","").replace("))","").replace("(","").replace(")","").replace("<","").replace(">","")).some(ans => currentPageAnswers.includes(ans))
                    ||
                    (answer.showIf.includes("!==")
                      ? 
                      !answer.showIf.replace("<>", "!==")?.replace(/</g, "")?.replace(/>/g, "").split(/\|\||&&/).map(ans => ans.replace("((","").replace("))","").replace("(","").replace(")","").replace("<","").replace(">","").replace("!=", "")).some(ans => allAnsweredQuestions.includes(ans))
                      : 
                    showQuestion(answer.showIf))
                  : true) && answer.AnswerLabel && (
                  <StyledOption
                    selected={answeredQuestions[currentPage - 1]?.find((selectedAnswer) =>
                      selectedAnswer === question.Answers[index].Expression
                    )}
                    key={index}
                    value={question.Answers[index].Expression}
                  >
                    {question.Answers[index].AnswerLabel}
                  </StyledOption>
                )}
            )}
          </StyledSelect>
        </StyledDropdown>
      </>
    );
  } else {
    return <></>
  }

};

const StyledDropdown = styled.div`
  position: relative;
  display: inline-block;
  margin-bottom: 1em;
`;

const StyledSelect = styled.select`
  appearance: none;
  background-color: #5bc5cd;
  color: white;
  padding: 1em;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  position: relative;
  padding-right: 2em; /* Add space for the arrow */
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24"><path fill="white" d="M7 10l5 5 5-5z"/></svg>');
  background-repeat: no-repeat;
  background-position: right 1em center;
  background-size: 20px;
  width: 100%;

  &::-ms-expand {
    display: none;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(91, 197, 205, 0.5);
  }

  /* Change the arrow direction when the dropdown is open */
  &:focus {
    background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24"><path fill="white" d="M7 14l5-5 5 5z"/></svg>');
  }
`;

const StyledOption = styled.option`
  background-color: white;
  color: #333;
`;

export default Dropdown;
